import { gql } from '@apollo/client'

export const ADMIN_AUDIT_INVENTORY_ITEM_FRAGMENT = gql`
  fragment AdminAuditInventoryItem on AuditInventoryItem {
    __typename
    id
    upc
    quantity
    predictedQuantity {
      caseEstimate
      caseLower
      caseUpper
    }
  }
`
